export default __webpack_public_path__ + "static/media/sec-gen_2025.07cef6ac.jpg";